(function () {
  'use strict';

  let globalListenersBound = false;

  function onBackdropClick(e) {
    if (e.target.className === 'spl-scene' || e.target.className === 'spl-pane') {
      if (e.target.localName !== 'img') {
        Spotlight.close();
      }
    }
  }

  function onDocumentKeydown(e) {
    if (e.key !== 'Escape') return;
    const spotlight = document.getElementById('spotlight');
    if (spotlight && spotlight.classList.contains('show')) {
      Spotlight.close();
    }
  }

  function bindGlobalListenersOnce() {
    if (globalListenersBound) return;
    globalListenersBound = true;
    document.body.addEventListener('click', onBackdropClick);
    document.addEventListener('keydown', onDocumentKeydown);
  }

  function refreshSpotlight() {
    if (typeof Spotlight === 'undefined') {
      setTimeout(refreshSpotlight, 100);
      return;
    }

    Spotlight.init({
      autohide: false,
    });
    bindGlobalListenersOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSpotlight);
  } else {
    refreshSpotlight();
  }

  document.addEventListener('product:variant-change', function () {
    setTimeout(refreshSpotlight, 200);
  });
})();
